import { useState } from 'react';
import AddDomainDrawerContent from '../../Domain/components/AddDomainDrawerContent';
import { Col, Row } from 'react-bootstrap';
import { useGetTariffInfoQuery } from '@/app/KeywordTracker/api/keywordsApi';

import { useMembershipWizard } from '../context/MembershipWizardContext';

const AddDomains = () => {
  const [competitorsCount, setCompetitorsCount] = useState(0);
  const membershipWizard = useMembershipWizard();
  const skipKeywordsStep = membershipWizard?.skipKeywordsStep ?? false;
  const { data: limitInfo, isFetching: isFetchingLimitInfo } =
    useGetTariffInfoQuery(null);

  return (
    !isFetchingLimitInfo && (
      <Row className="justify-content-center mb-6 px-3">
        <Col xs={12} md={8}>
          <AddDomainDrawerContent
            isMemberStep
            skipKeywordsStep={skipKeywordsStep}
            competitorsCount={competitorsCount}
            setCompetitorsCount={setCompetitorsCount}
            maxCompetitors={limitInfo?.data?.tariff?.num_of_competitors || 1}
          />
        </Col>
      </Row>
    )
  );
};

export default AddDomains;
